var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagonLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 71,
    viewBox: "0 0 82 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hexagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 204",
    d: "M56.7953 0.992676H25.5367C22.755 0.992676 20.1729 2.43767 18.7181 4.80861L2.77586 30.789C1.21403 33.3343 1.19983 36.5375 2.73901 39.0965L18.7279 65.6793C20.1747 68.0847 22.7764 69.5558 25.5834 69.5558H56.7487C59.57 69.5558 62.1827 68.0698 63.6247 65.6448L79.4329 39.0617C80.9444 36.5199 80.9304 33.3516 79.3965 30.8232L63.635 4.84317C62.1846 2.45257 59.5914 0.992676 56.7953 0.992676Z",
    fill: "#F4F6F8",
    stroke: "#919EAB",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonLocation);
export default __webpack_public_path__ + "static/media/hexagon_location.0827259a685cd05181ef49c598c81898.svg";
export { ForwardRef as ReactComponent };